import { render, staticRenderFns } from "./ProductOptionsDropdowns.vue?vue&type=template&id=b5f84c5e&scoped=true&"
import script from "./ProductOptionsDropdowns.vue?vue&type=script&lang=js&"
export * from "./ProductOptionsDropdowns.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionsDropdowns.vue?vue&type=style&index=0&id=b5f84c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f84c5e",
  null
  
)

export default component.exports